export default __webpack_public_path__ + "b2767409b8b608d2e6494c06a6962dee.svg";